module.exports = __webpack_public_path__ + "img/appltCourse-img17.2b076ff4.png";